/*
 *
 * Home actions
 *
 */

import {
  FLUSH_STATE_HOME,
  LOAD_HOME,
  LOAD_HOME_SUCCESS,
  LOAD_HOME_ERROR,
  CHANGE_HOME,
  CHANGE_HOME_SUCCESS,
  CHANGE_HOME_ERROR,
  DELETE_HOME,
  DELETE_HOME_SUCCESS,
  DELETE_HOME_ERROR,
} from './constants';

/**
 * Clearing the state for Home
 */
export function flushStateHome() {
  return {
    type: FLUSH_STATE_HOME,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Home, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_HOME
 */
export function loadHome() {
  return {
    type: LOAD_HOME,
  };
}

/**
 * Dispatched when the loadHome are loaded by the request saga
 *
 * @param  {array} variables true for Home
 *
 * @return {array} An action object with a type of LOAD_HOME_SUCCESS passing the variables
 */
export function loadHomeSuccess(homeList) {
  return {
    type: LOAD_HOME_SUCCESS,
    homeList,
  };
}

/**
 * Dispatched when loading the loadHome fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_HOME_ERROR passing the error
 */
export function loadHomeError(error) {
  return {
    type: LOAD_HOME_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the Home, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_HOME
 */
export function changeHome(homeData) {
  return {
    type: CHANGE_HOME,
    homeData,
  };
}

/**
 * Dispatched when the changeHome are changed/updated by the request saga
 *
 * @param  {array} variables true for Home
 *
 * @return {array} An action object with a type of CHANGE_HOME_SUCCESS passing the variables
 */
export function changeHomeSuccess(homeData) {
  return {
    type: CHANGE_HOME_SUCCESS,
    homeData,
  };
}

/**
 * Dispatched when loading the changeHome fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_HOME_ERROR passing the error
 */
export function changeHomeError(error) {
  return {
    type: CHANGE_HOME_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the Home, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_HOME
 */
export function deleteHome(id) {
  return {
    type: DELETE_HOME,
    id,
  };
}

/**
 * Dispatched when the deleteHome are deleted by the request saga
 *
 * @param  {object} variables true for Home
 *
 * @return {object} An action object with a type of DELETE_HOME_SUCCESS passing the variables
 */
export function deleteHomeSuccess() {
  return {
    type: DELETE_HOME_SUCCESS,
  };
}

/**
 * Dispatched when loading the deleteHome fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_HOME_ERROR passing the error
 */
export function deleteHomeError(error) {
  return {
    type: DELETE_HOME_ERROR,
    error,
  };
}
